var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v2-card',{attrs:{"no-padding":true}},[_c('v2-table',{attrs:{"columns":_vm.columns,"items":_vm.selections},scopedSlots:_vm._u([{key:"cell(selectionName)",fn:function(ref){
var item = ref.item;
return [_c('a',{staticClass:"v2-sales-analytics-list__link",on:{"click":function($event){return _vm.$emit('click-selection', item)}}},[_vm._v(" "+_vm._s(item.selectionName)+" ")])]}},{key:"cell(email)",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"v2-font-semibold"},[_vm._v(" "+_vm._s(item.email)+" ")])]}},{key:"cell(sharedDate)",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getDateAndTime(item.sharedDate))+" ")]}},{key:"cell(isEmailOpened)",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.isEmailOpened ? 'Yes' : 'No')+" ")]}},{key:"cell(isClicked)",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.isClicked ? 'Yes' : 'No')+" ")]}},{key:"cell(lastEmailOpenedAt)",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.isEmailOpened ? _vm.getDateAndTime(item.lastEmailOpenedAt) : '')+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }